// extracted by mini-css-extract-plugin
export var drawerPaper = "_22-0";
export var itemImage = "_22-1";